export default {
    GET_CART: '/wcs/resources/store/15951/cart/@self',
    GET_LENSES: '/wcs/resources/store/15951/catalog/##CATALOGID##/rxc/frameId/##FRAMEID##/lenses',
    GET_SHIPPING_MODES: '/wcs/resources/store/15951/cart/shipping_modes',
    DELETE_ORDER_ITEM: '/wcs/resources/store/15951/cart/@self/deleteFrame',
    UPDATE_SHIPPING_INFO: '/wcs/resources/store/15951/cart/@self/updateShipping',
    GET_PROMO_CODES: '/wcs/resources/store/15951/cart/@self/assigned_promotion_code',
    POST_PROMO_CODES: '/wcs/resources/store/15951/cart/@self/assigned_promotion_code',
    DELETE_PROMO_CODES: '/wcs/resources/store/15951/cart/@self/assigned_promotion_code',
    VALIDATE_ADDRESS: '/wcs/resources/store/15951/cart/@self/updateShipping',
    ADD_ADDRESS: '/wcs/resources/store/15951/cart/@self/addAddress',
    GET_ADDRESS: '/wcs/resources/store/15951/cart/@self/usable_billing_address',
    GET_PRESCRIPTION: '/wcs/resources/store/15951/prescription/orders',
    SEND_PRESCRIPTION: '/wcs/resources/store/15951/cart/@self/sendPrescription',
    ADD_PAYMENT: '/wcs/resources/store/15951/cart/@self/addPayment',
    PREPARE_PAYMENT: '/wcs/resources/store/15951/cart/@self/prepareOrder',
    SUBMIT_PAYMENT: '/wcs/resources/store/15951/cart/@self/checkout',
    GET_ORDER: '/wcs/resources/store/15951/ordercst/guest',
    SET_FAQ: '/wcs/resources/store/15951/espot/X_Cart_FAQs',
    SET_PERSON: '/wcs/resources/store/15951/person/@self',
    GET_ESPOT: '/wcs/resources/store/15951/espot/',
    GET_ESPOT_TYP: '/wcs/resources/store/15951/espot/X_ThankyouPage',
    GET_ESPOT_FOOTER: '/wcs/resources/store/15951/espot/X_Footer_Checkout',
    URL_GET_STORE_BOSS:
    '/wcs/resources/store/##STOREID##/storelocator/filtered/latitude/##LAT##/longitude/##LNG##?pageSize=##PAGESIZE##&offset=0&radius=##RADIUS##',
    URL_GET_STORE_BOSS_SELECTED:
    '/wcs/resources/store/##STOREID##/storelocator/filtered/identifier/##IDENTIFIER##',
    URL_SET_STORE_BOSS: '/wcs/resources/store/##STOREID##/shipinstore/updateShipInStoreInfo',
    ADD_ADDRESS_BOSS: '/wcs/resources/store/##STOREID##/shipinstore/updateBossInfoInAddress',
    ADD_TO_CART: '/webapp/wcs/stores/servlet/GLOrderItemAddGlassesCmd',
    CALCULATE_INSURANCE_BENEFIT: '/wcs/resources/store/15951/catalog/##CATALOGID##/ria/calculateBenefit',
    ADD_WARRANTY: '/wcs/resources/store/15951/cart/addWarranty',
    ORDER_CALCULATE: '/webapp/wcs/stores/servlet/AjaxOrderCalculate',
    GET_LENS_PACKAGES_DATAMANAGER: 'package_##FRAMEID##.json.zip',
    GET_SPEEDY_DETAILS: '/wcs/resources/store/15951/speedyDetails/orderDetails?orderId=##ORDERID##&nocache=##NOCACHE##'
};
